import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import {Grid } from '@material-ui/core';
import { Box, Card, CardContent, Button } from '@mui/material';
import MainCard from '../MainCard';
import axios from "../../../components/axios";
import NestlingImageCommon from './NestlingImageCommon';
import NestlingRadioPlatform from './NestlingRadioPlatform';
import NestlingRadioDevice from './NestlingRadioDevice';


const NestlingUploadForm = ({title, columns, queryURL, downloadURL}) => {
  const navigate = useNavigate();
  const [affernetType, setAffernetType] = useState("url");
  const [affernetUpload, setAffernetUpload] = useState("");
  const [affernetURL, setAffernetURL] = useState("");
  const [DMType, setDMType] = useState("url");
  const [DMUpload, setDMUpload] = useState("");
  const [DMURL, setDMURL] = useState("");
  const [platform, setPlatform] = useState("Topaz");
  const [device, setDevice] = useState("");
  const [disablePrism, setDisablePrism] = useState(false);
  const [disableTitan, setDisableTitan] = useState(false);
  const [disableCaesar, setDisableCaesar] = useState(false);
  const [disableV1, setDisableV1] = useState(false);
  const styleButton = {
    backgroundColor: "#406599",
    color: "#fff",
    borderRadius: "5px",
    boxSizing: "border-box",
    fontFamily: '"Roboto", "sans-serif"',
    fontSize: "15px",
  };

  const styleSendButton = {
    marginTop: "10px",
    color:'#406599',
    fontFamily: '"Roboto", "sans-serif"',
  };

  const styleToggle = {
    color:'#406599',
    fontFamily: '"Roboto", "sans-serif"',
  };

  const handleSendButton = () => {
    var input_data = JSON.stringify({ platform: platform, cfx_devices: device, files: [
      {target:'Affernet',url:affernetURL, upload:affernetUpload},{target:'DM',url:DMURL, upload:DMUpload}]});

    axios.post("/peloton/v1/automation/nestling-item",input_data,{withCredentials: true})
    .then(response => {
      if (response.data.message === "success") {
        setAffernetUpload('');
        setAffernetURL('');
        setDMUpload('');
        setDMURL('');
        setPlatform('');
        setDevice('');
        setAffernetType('url');
        setDMType('url');
      }
      alert(response.data.message);
    }).catch(function(err){
      if (!err.response){
            alert(err);
      }else{
        if (err.response.status === 401){
          alert(err.response.data.message);
          navigate("/");
        }else{
          console.log('error.response.status: ', err.response.status)
          console.log('error.response.status: ', err.response.data.message)
          alert(err.response.data.message)
        }
      }
    })
  };

  const handlePlatformChange = (
    event: React.MouseEvent<HTMLElement>,
    newPlatform: string,
  ) => {
    setPlatform(newPlatform);
    setDevice('');
    if (newPlatform === 'Topaz'){
      setDisablePrism(false);
      setDisableTitan(false);
      setDisableCaesar(false);
      setDisableV1(true);
    }else if (newPlatform === 'Amber' || newPlatform === 'Obsidian'){
      setDisablePrism(true);
      setDisableTitan(true);
      setDisableCaesar(true);
      setDisableV1(false);
    }else {
      setDisablePrism(true);
      setDisableTitan(true);
      setDisableCaesar(true);
      setDisableV1(true);
    }
  };

  const handleDeviceChange = (
    event: React.MouseEvent<HTMLElement>,
    newDevice: string,
  ) => {
    setDevice(newDevice);
  };

  return (
    <MainCard title={title}>
      <Card variant="outlined" sx={{ bgcolor: "white" }}>
      <CardContent>
      <Box sx={{ fontSize: '20px', color:"#406599", pb:'15px'}}>
          {title}
      </Box>
      <Box sx={{ fontSize: '15px', color:"#406599", pt:'15px'}}>
          Target Test App
      </Box>
      <NestlingImageCommon linkType={affernetType} setLinkType={setAffernetType} urlPath={affernetURL} setURLPath={setAffernetURL} uploadPath={affernetUpload} setUploadPath={setAffernetUpload} imageName="Affernet" styleButton={styleButton} styleToggle={styleToggle} />
      <NestlingImageCommon linkType={DMType} setLinkType={setDMType} urlPath={DMURL} setURLPath={setDMURL} uploadPath={DMUpload} setUploadPath={setDMUpload} imageName="DM" styleButton={styleButton} styleToggle={styleToggle}/>
      <NestlingRadioPlatform value={platform} styleToggle={styleToggle} onChange={handlePlatformChange}/>
      <NestlingRadioDevice value={device} styleToggle={styleToggle} onChange={handleDeviceChange} disablePrism={disablePrism} disableTitan={disableTitan} disableCaesar={disableCaesar} disableV1={disableV1}/>
      </CardContent>
      </Card>
      <Grid container justifyContent="flex-end" style={styleSendButton}>
        <Button style={styleButton} onClick={handleSendButton}>Send</Button>
      </Grid>
    </MainCard>
  );
};

export default NestlingUploadForm;
